export default "__VITE_ASSET__DXu1h8RG__"